import React, { Component, Fragment } from "react";
import classnames from "classnames";
import _ from "i18n";

import { TiWarningOutline } from "react-icons/ti";
import { UsersIcon, UserIcon } from "../Common/Icons";
import { SimplePieChart } from "../Common/Charts/PieChart";

import collaboratorApi from "../../services/CollaboratorServices";
import styles from "./CollaboratorSpace.local.scss";

class CollaboratorPerformances extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      data: [],
      error: false
    };
  }

  componentDidMount() {
    const { year } = this.props;
    this.handleUpdateCollaboratorPerformances(year);
  }

  componentDidUpdate(prevProps, prevState) {
    const { year } = this.props;
    if (prevProps.year !== year) {
      this.handleUpdateCollaboratorPerformances(year);
    }
  }

  handleUpdateCollaboratorPerformances = year => {
    const { user, organization } = this.props;
    this.setState({ loading: true });
    collaboratorApi
      .getCollaboratorPerformances(organization.uen, user.id, year)
      .then(response => {
        this.setState({
          data: response.data.data,
          loading: false
        });
      })
      .catch(error => {
        this.setState({
          error: error,
          loading: false
        });
      });
  };

  getPerformancesFetching = () => {
    const { synchro } = this.props;
    let performancesFetching = [];
    let k = synchro ? 2 : 1;
    for (let i = 0; i < k; i++) {
      performancesFetching.push(
        <div
          key={i}
          className={classnames(
            synchro ? "small-6" : "",
            styles.frame_fetching,
            styles.frame
          )}
          style={{ width: !synchro ? "100%" : "" }}
        >
          <div className={styles.title}>
            <div className={styles.gradiant} />
            <div className={classnames(styles.icone, styles.gradiant)} />
          </div>
          <div className={styles.content}>
            <div className={styles.message}>
              <div className={styles.gradiant} />
              <div className={styles.gradiant} />
            </div>
            <div className={styles.chart}>
              <SimplePieChart
                activeIndex={1}
                payload={0}
                data={[
                  {
                    id: 2,
                    value: 40,
                    percentage: 50,
                    total: 80
                  },
                  {
                    id: 3,
                    value: 0,
                    percentage: 0,
                    total: 80
                  }
                ]}
                width={90}
                height={90}
              />
            </div>
          </div>
        </div>
      );
    }
    return performancesFetching;
  };

  renderPerformancesDataCallout = () => {
    let performancesError = [];
    for (let i = 0; i < 2; i++) {
      performancesError.push(
        <div key={i} className={styles.frame}>
          <TiWarningOutline />
        </div>
      );
    }
    return performancesError;
  };

  renderPerformancesData = () => {
    let { data } = this.state;
    const { synchro } = this.props;
    let collaboratorData =
      data.collaborator && data.collaborator[0] ? data.collaborator[0] : [];
    let organizationData =
      data.organization && data.organization[0] ? data.organization[0] : [];
    return (
      <Fragment>
        {synchro ? (
          <div className={classnames("small-6", styles.frame)}>
            <div className={styles.title}>
              <h5>{_("Av. individuel")}</h5>
              <UserIcon size={28} />
            </div>
            <div className={styles.content}>
              <div className={styles.message}>
                <p>
                  {_(
                    this.getCommentByPercentage(
                      collaboratorData.percentage,
                      "collaborator"
                    )
                  )}
                </p>
              </div>
              <div className={styles.chart}>
                <SimplePieChart
                  activeIndex={0}
                  payload={collaboratorData.total}
                  data={data.collaborator}
                  width={90}
                  height={90}
                />
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
        <div
          className={classnames(synchro ? "small-6" : "", styles.frame)}
          style={{ width: !synchro ? "100%" : "" }}
        >
          <div className={styles.title}>
            <h5>{_("Av. collectif")}</h5>
            <UsersIcon size={24} />
          </div>
          <div className={styles.content}>
            <div className={styles.message}>
              <p>
                {_(
                  this.getCommentByPercentage(
                    organizationData.percentage,
                    "organization"
                  )
                )}
              </p>
            </div>
            <div className={styles.chart}>
              <SimplePieChart
                activeIndex={0}
                payload={organizationData.total}
                data={data.organization}
                width={90}
                height={90}
              />
            </div>
          </div>
        </div>
      </Fragment>
    );
  };

  // getCommentByPercentage = (percentage, target) => {
  //   let index = 0;
  //   let convertedPercentage = parseInt(percentage, 10);
  //   switch (true) {
  //     case convertedPercentage < 26:
  //       index = 0;
  //       break;
  //     case convertedPercentage < 51:
  //       index = 1;
  //       break;
  //     case convertedPercentage < 76:
  //       index = 2;
  //       break;
  //     case convertedPercentage < 101:
  //       index = 3;
  //       break;
  //     default:
  //       index = 4;
  //   }
  //
  //   return index < 4
  //     ? COMMENTS[target][index][Math.floor(Math.random() * 4)]
  //     : "percentatgeNonTranslated";
  // };

  // TEMPORAIRE POUR DEMO
  getCommentByPercentage = (percentage, target) => {
    let convertedPercentage = parseInt(percentage, 10);

    if (target === "collaborator") {
      if (convertedPercentage < 10) {
        return "C’est le moment de vous y mettre!";
      } else {
        return "Déjà " + convertedPercentage + "%, continuer vos efforts!";
      }
    } else {
      return "Déjà " + convertedPercentage + "%, en avant la team!";
    }
  };

  render() {
    let { loading, error } = this.state;
    return (
      <div className={classnames("small-12", styles.frames_section)}>
        {loading && this.getPerformancesFetching()}
        {error ? (
          <div className={styles.error_frames}>
            {this.renderPerformancesDataCallout()}
          </div>
        ) : (
          !loading && this.renderPerformancesData()
        )}
      </div>
    );
  }
}

export default CollaboratorPerformances;



// WEBPACK FOOTER //
// ./src/components/CollaboratorSpace/CollaboratorPerformances.js